import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  SimpleModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@ami/react/core';
import { couplerDecision } from '../../../quotes/otherQuoteEntities';
import { QuoteCouplerStyle } from '../../../quotes/quoteProductConfiguration';
import { ReviewQuoteCouplerDecisionModalContent } from './ReviewQuoteCouplerDecisionModalContent';
import { makeValidable } from '@ami/react/core';
import ReviewQuoteSpinnerComponent from '../ReviewQuoteSpinnerComponent';

const ValidableModalContent = makeValidable(
  ReviewQuoteCouplerDecisionModalContent
);

export class ReviewQuoteCouplerDecisionModal extends React.Component {
  constructor(props) {
    super(props);
    this.validableRef = React.createRef();
    this.state = {
      decision: this.getInitialDecision(props),
      couplerStyleId: this.getInitialCouplerStyleId(props),
      couplerOilReady: this.getInitialCouplerOilReady(props),
      showValidations: false,
    };
  }

  static propTypes = {
    show: PropTypes.bool.isRequired,
    onSave: PropTypes.func.isRequired,
    onHide: PropTypes.func.isRequired,
    attachmentPoint: PropTypes.object.isRequired,
    anyCouplerAffected: PropTypes.bool.isRequired,
    defaultCouplerType: PropTypes.string,
    couplerStyles: PropTypes.arrayOf(PropTypes.instanceOf(QuoteCouplerStyle))
      .isRequired,
    loadingNewConfiguration: PropTypes.bool.isRequired,
    currentDecision: PropTypes.string,
    currentCouplerStyleId: PropTypes.string,
    currentCouplerOilReady: PropTypes.string,
    productGroupIdsPerType: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string.isRequired,
        productGroupIds: PropTypes.arrayOf(PropTypes.string).isRequired,
      })
    ).isRequired,
    isFromStep2: PropTypes.bool.isRequired,
    isNarrowLayout: PropTypes.bool,
    showDecideLater: PropTypes.bool,
    currentManufacturer: PropTypes.string,
  };

  static defaultProps = {
    showDecideLater: true,
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      const decision = this.getInitialDecision(this.props);
      const couplerStyleId = this.getInitialCouplerStyleId(this.props);
      const couplerOilReady = this.getInitialCouplerOilReady(this.props);
      this.setState({ decision, couplerStyleId, couplerOilReady });
    }
  }

  getInitialDecision(props) {
    return props.currentDecision;
  }

  getInitialCouplerStyleId(props) {
    return props.currentCouplerStyleId;
  }

  getInitialCouplerOilReady(props) {
    return props.currentCouplerOilReady;
  }

  save = (e) => {
    const { isFromStep2, onSave } = this.props;
    const { decision, couplerStyleId, couplerOilReady } = this.state;
    if (isFromStep2) {
      const isValidForNow = !(
        (decision === couplerDecision.amiCoupler ||
          decision === couplerDecision.existingCoupler ||
          decision === couplerDecision.amiTiltRotator ||
          decision === couplerDecision.existingTiltRotator) &&
        !couplerStyleId
      );
      if (isValidForNow) {
        onSave(decision, couplerStyleId, couplerOilReady);
      }
    } else {
      if (e) e.preventDefault();
      this.setState({ showValidations: true }, () => {
        if (this.validableRef.current.isValid()) {
          onSave(decision, couplerStyleId, couplerOilReady);
        }
      });
    }
  };

  render() {
    const { decision, couplerStyleId, couplerOilReady, showValidations } =
      this.state;
    const {
      show,
      attachmentPoint,
      anyCouplerAffected,
      couplerStyles,
      defaultCouplerType,
      loadingNewConfiguration,
      productGroupIdsPerType,
      isFromStep2,
      isNarrowLayout,
      showDecideLater,
      currentManufacturer,
    } = this.props;
    const showExistingCouplerSelection =
      anyCouplerAffected ||
      decision === couplerDecision.amiCoupler ||
      decision === couplerDecision.existingCoupler ||
      decision === couplerDecision.amiTiltRotator ||
      decision === couplerDecision.existingTiltRotator;
    const content = (
      <ValidableModalContent
        show={show}
        ref={this.validableRef}
        attachmentPoint={attachmentPoint}
        showValidations={showValidations}
        anyCouplerAffected={anyCouplerAffected}
        decision={decision}
        couplerStyleId={couplerStyleId}
        couplerOilReady={couplerOilReady}
        defaultCouplerType={defaultCouplerType}
        showExistingCouplerSelection={showExistingCouplerSelection}
        couplerStyles={couplerStyles}
        onStateChanged={(updated) => {
          this.setState(updated, () => {
            if (
              anyCouplerAffected &&
              decision === couplerDecision.notSpecified &&
              this.state.couplerStyleId
            ) {
              this.setState({ decision: couplerDecision.amiCoupler });
            }
            if (isFromStep2) {
              this.save();
            }
          });
        }}
        productGroupIdsPerType={productGroupIdsPerType}
        isNarrowLayout={isNarrowLayout}
        showDecideLater={showDecideLater}
        currentManufacturer={currentManufacturer}
      />
    );
    if (isFromStep2) {
      return <Fragment>{content}</Fragment>;
    }
    return (
      <SimpleModal show={show} size="lg">
        <ReviewQuoteSpinnerComponent show={loadingNewConfiguration} />
        <ModalHeader title="Lugging Selection" />
        <ModalBody>{content}</ModalBody>
        <ModalFooter>
          <button className="btn btn-secondary" onClick={this.props.onHide}>
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={this.save}
            disabled={loadingNewConfiguration}
          >
            {loadingNewConfiguration ? (
              <span>
                <i className="fa fa-spin fa-spinner" /> Applying
              </span>
            ) : (
              <span>Apply</span>
            )}
          </button>
        </ModalFooter>
      </SimpleModal>
    );
  }
}
